jQuery(document).ready(function () {
  
	jQuery("body").each(function() {

      if( $("body").hasClass('template-index') || $("body").hasClass('template-page') )
      {
        function settop(){
           //$topbar_size =jQuery(".__seguno-banner-container").height();
            //alert($topbar_size);
            jQuery(".main-content").css({'padding-top': 0 });
          }
          jQuery(window).on('load resize orientationchange', settop);
      }
      else{
        function settop(){
			$header_size =(jQuery("header.site-header").height() );
          	$topbar_size =(jQuery(".__seguno-banner-container").height() );
			jQuery(".main-content").css({'padding-top':($header_size)});
		}
		jQuery(window).on('load resize orientationchange', settop);
      }

	});

    $('.minus').click(function () {
      var $input = $(this).parent().find('input.cart__qty-input');
      var count = parseInt($input.val()) - 1;
      count = count < 1 ? 1 : count;
      $input.val(count);
      $input.change();
      return false;
    });
    $('.plus').click(function () {
      var $input = $(this).parent().find('input.cart__qty-input');
      $input.val(parseInt($input.val()) + 1);
      $input.change();
      return false;
    });
  

	jQuery("body").each(function() {
		function settop(){
			$video =(jQuery(".support_help_instructions .navigation__text .rte-setting.rte").height());
          	$video_desc =(jQuery(".support_help_instructions .setUpVideos_wrap").height());
			jQuery(".support_help_instructions .shi_accordion").css({'height':($video)+($video_desc)+18});
		}
		jQuery(window).on('load resize orientationchange', settop);
	});

  
    
});	





